import { kebabCase, uniqueId } from "lodash";

export function isTempId(id) {
  return id?.[0] === "[";
}

export function isTempResource(resource) {
  return isTempId(resource?.id);
}

export default function tempId(type) {
  const prefix = `${kebabCase(type)}-`;
  return `[${uniqueId(prefix)}]`;
}
